// extracted by mini-css-extract-plugin
export default {"container":"UserInfo_container__M1GaD","title":"UserInfo_title__ZsqnC","btn":"UserInfo_btn__L6KBz"};